/**
 * Returns the (shallow) difference between the specified old and new objects
 *
 * Note this function is potentially brittle. It uses Object.entries which is unable to preserve typescript typing.
 * As a result we had to brute force typescript on certain lines. Functionally this works properly and has a test file,
 * but if something seems off, this is a good file to check.
 *
 * @param oldObj Original object from which to diff
 * @param newObj New object from which to keep updates
 * @returns {object} The resulting object with just the updated key/value pairs
 */
export function shallowDiff (oldObj: {[key: string]: any}, newObj: {[key: string]: any}): {[key: string]: any} {
  const res: {[key: string]: any} = {}
  Object.entries(newObj).forEach(([key, val]) => {
    if (val !== oldObj[key]) {
      res[key] = val
    }
  })
  return res
}
